module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_0.67f00f0c.png";